export default __webpack_public_path__ + "static/media/email-icon-hover-state.7f827301.svg";